module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filterbtn",
    class: _vm.classes,
    on: {
      "mousedown": function($event) {
        return _vm.doRipple($event)
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "ripple",
    style: (_vm.rippleStyle())
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8764208","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Filterbtn.vue
// module id = 622
// module chunks = 1